import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import AdminService from '../services/adminService';
import { useTranslation } from "react-i18next";
import { FaFileDownload } from "react-icons/fa";

const DownloadGuestsPDFButton = () => {
    const [loading, setLoading] = useState(false);
    const weddingId = useSelector((state) => state.userStore.user.weddingId);
    const { t } = useTranslation();

    const handleDownload = () => {
        if (!weddingId) {
            alert(t("error.weddingIdNotSet"));
            return;
        }

        setLoading(true);

        AdminService.downloadGuestsPDF(weddingId)
            .then((response) => {
                const url = window.URL.createObjectURL(response.data);

                const a = document.createElement('a');
                a.href = url;
                a.download = t("guestListFileName");
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
                setLoading(false);
            })
            .catch((err) => {
                console.error(err);
                alert(t("genericError"));
                setLoading(false);
            });
    };

    return (
        <button
            onClick={handleDownload}
            disabled={loading}
            className={`flex items-center pl-5 py-2 text-gray-800 hover:bg-blue-700 hover:text-white text-xl transition md:w-full ${loading ? 'opacity-50 cursor-not-allowed' : ''} `}>
            {loading ? <span className="flex items-center"><FaFileDownload className="mr-2 text-lg" /> {t("generatingPdf")}</span> : <span className="flex items-center"><FaFileDownload className="mr-2 text-lg" /> {t("downloadGuestList")}</span>}
        </button>
    );
};

export default DownloadGuestsPDFButton;
